<template>
  <div
    class="flex cursor-pointer items-center space-y-1 rounded-md p-2"
    :class="[{ 'bg-primary/10': active }, isMobile ? 'space-x-2' : 'flex-col']"
  >
    <div v-if="icon" class="relative">
      <component
        :is="TAB_ICONS[icon]"
        :class="active ? 'text-primary' : 'text-heading/70'"
        class="h-5 w-5"
        data-cy="nav-icon"
      />
      <span
        v-if="badgeCount"
        class="absolute -top-1 -right-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-error-500 px-1 text-xxs font-medium text-white"
        data-cy="nav-badge"
      >
        {{ badgeCount }}
      </span>
    </div>
    <div
      class="text-center text-xs"
      :class="active ? 'text-primary' : 'text-heading'"
      data-cy="nav-title"
    >
      {{ title }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { useResponsive } from "@/composables/common";
import TAB_ICONS from "@/components/icons/tabs";
import type { TabIcon } from "@/api/http/schemas/borrowerPlatformTemplatesSchemas";

const { isMobile } = useResponsive();

const {
  icon = undefined,
  title = "",
  active,
  badgeCount = 0,
} = defineProps<{
  icon?: TabIcon;
  title: string;
  active: boolean;
  badgeCount?: number;
}>();
</script>
